import React from 'react'

export const NavigationDrawerTenantLogo: React.FC<
  React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >
> = ({ children, ...props }) => null
